module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "livestats-table"
  }, [(Object.keys(_vm.liveStats()).length) ? _c('div', [_c('h4', {
    staticClass: "muted"
  }, [_vm._v("Overview for " + _vm._s(_vm.selectedPeriod))]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('streaming-overview-item', {
    attrs: {
      "statLabel": 'Total streams',
      "statValue": _vm.formatNumber(_vm.avgData.streaming.totalConnections)
    }
  }), _vm._v(" "), _c('streaming-overview-item', {
    attrs: {
      "statLabel": 'Unique listeners',
      "statValue": _vm.formatNumber(_vm.avgData.streaming.uniqueListeners)
    }
  }), _vm._v(" "), _c('streaming-overview-item', {
    attrs: {
      "statLabel": 'Average duration',
      "statValue": _vm.formatTime(_vm.avgData.streaming.averageDuration)
    }
  }), _vm._v(" "), _c('streaming-overview-item', {
    attrs: {
      "statLabel": 'Average concurrent streams',
      "statValue": _vm.avgData.streaming.averageConnections.toFixed()
    }
  }), _vm._v(" "), _c('streaming-overview-item', {
    attrs: {
      "statLabel": 'Maximum concurrent streams',
      "statValue": _vm.formatNumber(_vm.avgData.streaming.maxStreams)
    }
  }), _vm._v(" "), _c('streaming-overview-item', {
    staticClass: "label-success",
    attrs: {
      "statLabel": 'Live streams now',
      "statValue": _vm.formatNumber(_vm.liveStats().live_streams)
    }
  })], 1) : _c('div', [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (true),
      expression: "true"
    }],
    staticClass: "loading",
    staticStyle: {
      "width": "100%"
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0d36f8cc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/analytics/programmingDashboard/StreamingOverviewTable.vue
// module id = 3138
// module chunks = 3